export enum LOCALES { EN_US = 'en-US', NL_NL = 'nl-NL', FR_FR = 'fr-FR', DE_DE = 'de-DE' }
